import { FC } from 'react';

import { GridLayout, VSpacing } from '@hh.ru/magritte-ui';

import { AdfoxInfo } from 'components/Admin/AdfoxInfo/AdfoxInfo';
import { AdminHeader } from 'components/Admin/AdminHeader/AdminHeader';
import Nav from 'components/Admin/Nav/Nav';

export const AdfoxInfoPage: FC = () => (
    <>
        <AdminHeader />
        <GridLayout>
            <VSpacing default={24} />
            <Nav />
            <AdfoxInfo />
        </GridLayout>
    </>
);
